var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, EventEmitter, Output } from '@angular/core';
var GraphStateListComponent = /** @class */ (function () {
    function GraphStateListComponent() {
        this.selectedStateIdChange = new EventEmitter();
    }
    Object.defineProperty(GraphStateListComponent.prototype, "selectedStateId", {
        get: function () {
            return this._selectedStateId;
        },
        set: function (value) {
            this._selectedStateId = value;
            this.selectedStateIdChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    GraphStateListComponent.prototype.selectState = function (stateId) {
        this.selectedStateId = stateId;
    };
    __decorate([
        Input()
    ], GraphStateListComponent.prototype, "stateList", void 0);
    __decorate([
        Input()
    ], GraphStateListComponent.prototype, "selectedStateId", null);
    __decorate([
        Output()
    ], GraphStateListComponent.prototype, "selectedStateIdChange", void 0);
    GraphStateListComponent = __decorate([
        Component({
            selector: 'graph-state-list',
            template: "<div *ngFor=\"let state of stateList\" class=\"graphList\"> <div *ngIf=\"state.url\" class=\"graph\" (click)=\"selectedStateId=state.id\" [class.selectedGallery]=\"state.id==selectedStateId\"> <img src=\"{{state.url}}\" crossorigin=\"anonymous\" width=\"100%\" height=\"100%\" alt=\"\"> </div> <span>{{state.name}}</span> </div> ",
            styles: [" .graphList { text-align: center; float: left; width: 64px; height: 100px; margin-left: 10px; margin-top: 10px; .graph { width: 64px; height: 64px; border: 2px solid transparent; display: flex; cursor: pointer; justify-content: center; .svgGraph>svg { width: 100%; height: 100%; } img{ width: auto; height: auto; max-width: 100%; max-height: 100%; align-self: center; } } span { font-size: 12px; word-break: break-word; } .graph.selectedGallery { border-color: #2d89ef; } } .inline-control{ display: inline-block; }"]
        })
    ], GraphStateListComponent);
    return GraphStateListComponent;
}());
export { GraphStateListComponent };
